import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Tooltip, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useChargebackDetailsModel } from "./chargebackDetailsModels";
import { IMaterialDetailList } from "../../chargebackType";
import { formatIntPoint, repairFormatNum, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { DetailType, IServiceNatureCodeType } from "@/types/ScmEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { ITopType } from "@/types/ScmTypes";
import { YhBut } from "@/components/YhButton";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";

export const MaterialTableBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const { getSettlementParty } = useGlobalModel();

    const {
        detailAddForm,
        detailEditForm,
        setMaterialModel,
        detailMaterialAddList, setDetailMaterialAddList,
        detailMaterialAddDataRowKeys, setDetailMaterialAddDataRowKeys,
        setDetailMaterialAddDataRow,
        detailMaterialEditList, setDetailMaterialEditList,
        detailMaterialEditDataRowKeys, setDetailMaterialEditDataRowKeys,
        setDetailMaterialEditDataRow,
        detailMaterialLookList,
        detailMaterialDetailList,
        setTopButsControl,
        setHistoryVisible,
        setHistoryRow
    } = useChargebackDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onHistoryModel = (record: IMaterialDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const switchModelViaible = () => {
        IFormRef.current?.validateFields().then(async res => {
            if (mode === "add") {
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailEditForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                if (!(customerCode && customerName && payType && settlementPartyCode)) {
                    message.warning("请补全客户名称或结算类型或结算方")
                    return false
                }
                //     let { accountName, availableAmount, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });

                //     if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
                //         if (accountName && availableAmount > 0) {
                //             materialTips(`当前${accountName},授信额度为${availableAmount},是否确认？？`, true)
                //         } else if (accountName && availableAmount === 0) {
                //             materialTips(`当前${accountName},授信额度为${availableAmount}，不可开单，是否确认？？`, false)
                //         } else if (!accountName) {
                //             materialTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                //         }
                //     } else {
                setMaterialModel(true)
                //     }
            } else {
                setMaterialModel(true)
            }
        })
    }
    const materialTips = (info: string, visible: boolean) => {
        globalPrompt("modal", {
            title: "新增维修项目",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { visible && await setMaterialModel(visible) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_RETURN_SETTLE || detailEditForm.status === DictCodeEnmu.MAINTENANCE_RETURN_IO || detailEditForm.status === "maintenance.return.paying")) {
            return false;
        }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_R_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => switchModelViaible()}
                >新增商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_R_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailMaterialDetailList(mode)}
                >删除商品</Button>
            </YhAuth>
        </>}
    </>;
    const removeMaterial = (record: IMaterialDetailList) => {
        detailMaterialDetailList(mode, record)
    }
    const materialColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 100,
            dataIndex: 'materialCode',
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
            render: (text: any, record: any) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: isMaterialModel()
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: '配件费',
            width: 100,
            dataIndex: 'materialAmount',
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            // editable: isMaterialModel()
            render: (text: string) => text + "%"
        }, {
            title: '折后金额',
            width: 80,
            dataIndex: 'discountedAmount',
        }, {
            title: '单项优惠金额',
            width: 140,
            dataIndex: 'rdecreaseAmount'
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount'
            // }, {
            //     title: '原单小计',
            //     width: 100,
            //     dataIndex: 'originalAmount'
        }, {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isMaterialModel()
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
        }
    ];

    const typeMaterialList = {
        "add": [...detailMaterialAddList],
        "edit": [...detailMaterialEditList],
        "look": [...detailMaterialLookList],
    }
    const newSelectMaterialColums = () =>
        materialColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderReturn", "roleCodes": roles };
        return getRoleColumns("orderReturn", "维修用料", newSelectMaterialColums(), params);
    }, [roles, typeMaterialList[mode], materialColumns]);
    const handleMaterialSave = (row: IMaterialDetailList) => {
        let { num, price, discountRate, originalNum, rdecreaseAmount, discountedAmount } = row;
        const newServiceNatureCode = mode === "add" ? detailAddForm.serviceNatureCode : detailEditForm.serviceNatureCode;

        price = +formatNum(price)
        num = +formatIntPoint(num)
        // discountRate = +formatIntPoint(discountRate);  //折扣
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        if (num > originalNum) {
            num = originalNum as number;
            message.warning('修改数量时，不能大于原单的数量');
        }
        let newRow = {
            ...row,
            num: num,
            price: price,
            discountRate,
            discountedAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * price * discountRate) / 100) : +formatNum((num * price * discountRate) / 100),
            materialAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * price) : +formatNum(num * price),
            receivableAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * price * discountRate) / 100 - Number(rdecreaseAmount)) : +formatNum((num * price * discountRate) / 100 - Number(rdecreaseAmount)),
        }

        let newData = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailMaterialEditList([...newData]) : setDetailMaterialAddList([...newData])
        setTopButsControl(true)
    }

    //设置维修用料选中的行和数据
    const setTypeMaterialDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeMaterialDetailDataRow = async (selectedRows: IMaterialDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRow(selectedRows)
        }
    }

    return (
        <YhBox title="维修用料" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns}
                dataSource={typeMaterialList[mode] as IMaterialDetailList[]}
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailMaterialAddDataRowKeys : detailMaterialEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetailList[]) => {
                            setTypeMaterialDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
            />
        </YhBox>
    )
}